var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRemoveRedEye24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.2,
    height: 9,
    viewBox: "0 0 13.2 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.6,4.5A7.1,7.1,0,0,0,1,9,7.09,7.09,0,0,0,14.2,9,7.1,7.1,0,0,0,7.6,4.5Zm0,7.5a3,3,0,1,1,3-3A3,3,0,0,1,7.6,12Zm0-4.8A1.8,1.8,0,1,0,9.4,9,1.8,1.8,0,0,0,7.6,7.2Z",
    transform: "translate(-1 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRemoveRedEye24Px);
export default __webpack_public_path__ + "static/media/ic_remove_red_eye_24px.b56e3c32.svg";
export { ForwardRef as ReactComponent };